import { createSignal } from 'solid-js';
import * as v from 'valibot';
import { userStatusResponseSchema, type UserStatusResponse } from '@contracts/user/userStatusResponseSchema';

interface UseUserStatusState {
	data: UserStatusResponse | null;
	loading: boolean;
	error: string | null;
}

export function useUserStatus() {
	const [state, setState] = createSignal<UseUserStatusState>({
		data: null,
		loading: false,
		error: null,
	});

	const fetchUserStatus = async (): Promise<UserStatusResponse | null> => {
		setState({ data: null, loading: true, error: null });

		try {
			const response = await fetch('/api/user/status', {
				method: 'GET',
				credentials: 'include',
			});

			if (!response.ok) {
				if (response.status === 401) {
					setState({ data: null, loading: false, error: 'Not authenticated' });
					return null;
				}
				throw new Error(`Failed to fetch user status: ${response.status}`);
			}

			const json = await response.json();
			const result = v.parse(userStatusResponseSchema, json);

			setState({ data: result, loading: false, error: null });
			return result;
		} catch (error) {
			const errorMessage = error instanceof Error ? error.message : 'Unknown error';
			setState({ data: null, loading: false, error: errorMessage });
			return null;
		}
	};

	return {
		state,
		fetchUserStatus,
	};
}
